import React, { FunctionComponent, useContext, useEffect, useState } from 'react'
import { ISubscriptionOffersAddZoneData, useApi } from 'components/providers/ApiProvider'

interface Filter {
  zone: number
  type: number
  client: string
}

type RootState = {
  filter: Filter
  addZones: ISubscriptionOffersAddZoneData[]
  loadList: number
  listLoading: boolean
  listPerPage: number
  listPage: number
}

type RootFunctions = {
  setLoadList(): void
  setListLoading(status: boolean): void
  setListPage(value: number): void
  onFilter(filter: Filter): void
  onChangePerPage(perPage: number): void
  onChangePage(page: number): void
}

const InitialState: RootState = {
  filter: {
    zone: 0,
    type: 0,
    client: '',
  },
  addZones: [],
  loadList: 0,
  listLoading: false,
  listPerPage: 20,
  listPage: 1,
}

export const SubscriptionOffersContext = React.createContext<[RootState, (state: any) => void]>([InitialState, () => {
}])

export const SubscriptionOffersProvider: FunctionComponent = ({ children }) => {
  const api = useApi()

  const [state, setState] = useState<RootState>(InitialState)

  useEffect(() => {
    api.getSubscriptionOffersAddZones()
      .then(data => {
        setState((state: RootState) => ({
          ...state,
          addZones: data.zones,
        }))
      })
      .catch(() => {
      })
  }, [])

  return (
    <SubscriptionOffersContext.Provider value={[state, setState]}>
      {children}
    </SubscriptionOffersContext.Provider>
  )
}

export const useSubscriptionOffers = (): RootFunctions & RootState => {
  const [state, setState] = useContext(SubscriptionOffersContext)

  const setLoadList = () => {
    setState((state: RootState) => ({
      ...state,
      loadList: state.loadList + 1,
    }))
  }

  const setListLoading = (status: boolean) => {
    setState((state: RootState) => ({
      ...state,
      listLoading: status,
    }))
  }

  const setListPage = (value: number) => {
    setState((state: RootState) => ({
      ...state,
      listPage: value,
    }))
  }

  const onFilter = (filter: Filter) => {
    setState((state: RootState) => ({
      ...state,
      filter,
      loadList: state.loadList + 1,
      listPage: 1,
    }))
  }

  const onChangePerPage = (perPage: number) => {
    setState((state: RootState) => ({
      ...state,
      loadList: state.loadList + 1,
      listPerPage: perPage,
      listPage: 1,
    }))
  }

  const onChangePage = (page: number) => {
    setState((state: RootState) => ({
      ...state,
      loadList: state.loadList + 1,
      listPage: page,
    }))
  }

  return {
    setLoadList,
    setListLoading,
    setListPage,
    onFilter,
    onChangePerPage,
    onChangePage,
    ...state,
  }
}
